import { ID } from '@app/models';
import { CustomFieldRelationParam } from '.';
import { ModelBasic } from '..';
import { CustomFieldRelation, CustomFieldType } from './customfield';

export interface TemplateCustomAttributeGroup {
  id: ID;
  category_name: string;
  order_value: number;
}

export interface TemplateCustomAttributeGroupField extends ModelBasic {
  label: string;
  field_type: CustomFieldType;
  field_relation: CustomFieldRelation;
  is_required: boolean;
  placeholder: string;
  order_value: number;
  is_multi_select: boolean;
  count_cols: number;
  css_class: string;
  params: CustomFieldRelationParam[];
}
